export default __webpack_public_path__ + "static/media/riverdalePDRed.e91125ca.png";